import React, { Suspense, useState, useEffect } from 'react'
import { Layout, Breadcrumb } from 'antd';
import { LayoutStyle } from './style';
import HeaderPage from './header';
import MenuPage from './menu';
import { IMenuItem } from 'model';
import { FallbackLoading } from 'components';
import { setBreadcrumbState } from 'store/slice/title';
import { Outlet } from 'react-router-dom';
import { RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
const { Content } = Layout;

const LayoutPage = () => {
  const dispatch = useDispatch()
  const [menuList, setMenuList] = useState<Array<IMenuItem>>([])
  const breadcrumb = useSelector((state: RootState) => state.breadcrumbSlice)

  const handleClickMenu = (item: IMenuItem)=> {
    setMenuList(item.menuVOS);
  }
  
  useEffect(() => {
    const sessionSelectedKeys = sessionStorage.getItem('selectedKeys')
    const sessionOpenKeys = sessionStorage.getItem('openKeys')
    console.log(7777, menuList);
    
    if(!sessionSelectedKeys){
      // dispatch(setBreadcrumbState({ title: menuList[0].name, menuName: menuList[0].menuVOS[0].name + '/' +  menuList[0].menuVOS[0].menuVOS[0].name}))
    }
  },[])
  return (
    <LayoutStyle>
      <div className="menu">
        <div className="logo"></div>
        <MenuPage menuList={menuList}></MenuPage>
      </div>
      <div className="content">
        <div className="box">
          <div className="header">
            <HeaderPage clickMenu={handleClickMenu}></HeaderPage>
          </div>
          <div className="main">
            <div className="box">
              <Breadcrumb>
                <Breadcrumb.Item>{breadcrumb.title} / {breadcrumb.menuName}</Breadcrumb.Item>
              </Breadcrumb>
              <Content className="site-layout-background" >
                <Suspense fallback={<FallbackLoading />}>
                  <Outlet></Outlet>
                </Suspense>
              </Content>
            </div>
          </div>
        </div>
      </div>
    </LayoutStyle>
  )
}

export default LayoutPage;